import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const Questions = () => {
  const { t } = useLang();
  return (
    <section className="bg-pastel-violet py-16 md:py-24" data-testid="questions-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <h2 className="font-display text-4xl md:text-6xl leading-[1.05] tracking-tight text-navy max-w-3xl">
            {t.questions.title}
          </h2>
        </Reveal>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-12">
          {t.questions.items.map((q, i) => (
            <Reveal key={q} delay={0.08 * i}>
              <div className="border-t border-ser-purple/25 pt-6" data-testid={`question-${i + 1}`}>
                <span className="text-xs tracking-[0.2em] text-ser-purple/70 font-medium" aria-hidden="true">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="font-display text-2xl md:text-4xl leading-snug text-navy mt-3">{q}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-20 md:mt-28 flex items-center gap-4 font-display italic text-2xl md:text-3xl text-navy/85">
            <span className="w-2.5 h-2.5 rounded-full bg-ser-yellow shrink-0" aria-hidden="true" />
            {t.questions.closing}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
